import React, { Component } from 'react';
import { Switch, Route, Router } from 'react-router-dom';
import HeaderPage from '../projectmgmt/header/Header';
import ASRLeftPanel from './ASRLeftPanel';
class MainPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        {/* Navbar */}
        <div id="navBar">
          <HeaderPage />
        </div>
        {/* Left panel */}
        <div className="content-wrapper" id="leftPanel" >
              <Route path='/cloud-asr' component={ASRLeftPanel}></Route>
          {/* <LeftPanel />  */}
        </div>


      </div>




    );
  }
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/asrUi/ASRMainPage.js